import { Fade, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { Box } from "@mui/system";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { useInterval } from "react-use";
import InseaLogo from "~/assets/img/insea-no-text.svg";
import "./LoggedOutPage.css";

const useStyles = makeStyles(() => ({
  container: {
    height: "var(--full-vh, 100vh)",
    width: "100vw",
    overflow: "hidden",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    background:
      "radial-gradient(ellipse at center, rgb(255 255 255) 0%, rgb(255 255 255) 35%, #d4f1f3 100%);",
  },
  center: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
}));

const LoggedOutPage = (): JSX.Element => {
  const { t } = useTranslation("logged-out");
  const history = useHistory();
  const [time, setTime] = useState<number>(5);
  const classes = useStyles();

  useInterval(
    () => {
      setTime(time - 1);
      if (time <= 1) {
        history.push("/");
      }
    },
    time > 0 ? 1000 : null,
  );

  return (
    <div className={classes.container}>
      <Fade in={time > 1} exit enter timeout={{ exit: 1000, enter: 0 }}>
        <div className={classes.center}>
          <Box
            component="img"
            src={InseaLogo}
            sx={{ width: "200px", height: "200px" }}
          />
          <Typography variant="h4" textAlign="center">
            {t("logged-out")}
          </Typography>
          <Typography variant="h6" textAlign="center">
            {t("redirecting-in", { time })}
          </Typography>
        </div>
      </Fade>
      <div className="logout-ocean">
        <div className="logout-wave" />
        <div className="logout-wave" />
      </div>
    </div>
  );
};

export default LoggedOutPage;
